import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Form, Button, Grid  } from 'semantic-ui-react'; 
import { estados } from './Estados.js'; 

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const style = {
    tabla: { 
        backgroundColor: '#FBF6F5', 
    },
    div: { 
        marginTop: '20px', 
        marginBottom: '20px',
        alignContent: 'center',
        textAlign: 'center',  
    }
}

export default class Rechazado extends Component {
  
    constructor(props) {
      super(props);
      this.state = {
        isLoaded: false,
        error:'',
        caso:props.caso,
        casoFinal : null
      };
      
      //this._finalizarExpediente = this._finalizarExpediente.bind(this);

    }

    componentDidMount() {
        let METHODNAME = 'componentDidMount - ';
        console.log(METHODNAME + 'INI');
 
        auth0Client.isExpired();

        this.cargarDatosDelCasoFinalizado();

        console.log(METHODNAME + 'FIN');
    }
    
    cargarDatosDelCasoFinalizado(){
        let METHODNAME = 'cargarDatosDelCasoFinalizado - ';
        console.log(METHODNAME + 'INI');

        let url = server+`/caso/finalizado/${this.state.caso.casoId}/`;

        console.log(METHODNAME + `Traer el Caso finalizado con Id ${this.state.caso.casoId}`);

      fetch( 
          url , {
          method: 'GET',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          }
      })
      .then(res => res.json())
      .then(
          (result) => {

            console.log(METHODNAME + 'casoId = ' + result.caso.casoId );

            this.setState({
                isLoaded: true,
                casoFinal : result.caso
            });

            console.log(METHODNAME + 'state . casoFinalId = ' + this.state.casoFinal.casoId );

          },
          (error) => {
            console.log(METHODNAME + 'error = ' + error );
            this.setState({
                isLoaded: true,
                error
            });
          }
      )

        console.log(METHODNAME + 'FIN');
    }

    render() {
      
        const { error, isLoaded, casoFinal } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
                
            return(
                <Form>
                
                <h2>Caso rechazado</h2>
                
                <Form.Field>
                    
                    <h4> Resumen: </h4>
                    <table key='table1'>
                        <tbody>
                        <tr>
                            <th>Tipo de Resultado </th>
                            <td>{casoFinal.tipoResultado ? casoFinal.tipoResultado.nombre : '--'}</td>
                        </tr>
                        <tr>
                            <th>Tipo de Resolución Proyectada</th>
                            <td>{casoFinal.etapa && casoFinal.etapa.etapa ? casoFinal.etapa.etapa : '--' } </td>
                        </tr>
                        <tr>
                            <th>Fecha de fin de Analisis</th>
                            <td>{casoFinal.fechaFinAnalisis}</td>
                        </tr>
                        <tr>
                            <th>Proceso Constitucional</th>
                            <td>{casoFinal.tipoHabeasData ? casoFinal.tipoHabeasData.label : '--'}</td>
                        </tr>
                        <tr>
                            <th>RAC se presentado por</th>
                            <td>{casoFinal.racPresentadoPor ? casoFinal.racPresentadoPor.label : '--'}</td>
                        </tr>
                        <tr>
                            <th>Causa del rechazo</th>
                            <td>
                                <table>
                            {casoFinal.motivosRechazoDeForma &&
                                casoFinal.motivosRechazoDeForma.map(item => (                  
                                  <tr> <td>
                                  <label key={item.idPregunta}> 
                                        {item.respuesta}
                                  </label> 
                                  </td> </tr>
                            ))}
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <th>Resultado de la evaluación</th>
                            <td>{casoFinal.motivoPregunta && casoFinal.motivoPregunta.resultadoBoolean ? 'VERDADERO' : 'FALSO' }</td>
                        </tr>
                        <tr>
                            <th>Consecuencia de la resolución según el motivo del RAC</th>
                            <td>{casoFinal.resolucionRac ? casoFinal.resolucionRac.consecuencia : '' }</td>
                        </tr>
                        <tr>
                            <th>Motivo resolución RAC</th>
                            <td>{casoFinal.resolucionRac ? casoFinal.resolucionRac.motivo : ''}</td>
                        </tr>
                        <tr>
                            <th>Modelo Resolucion RAC</th>
                            <td>{casoFinal.resolucionRac && casoFinal.resolucionRac.modelo ? casoFinal.resolucionRac.modelo : 'Modelo por definir' } </td>
                        </tr>
                        </tbody>
                    </table>

                    { casoFinal.resolucionRac && casoFinal.resolucionRac.plantillas &&
                        <div style={style.div}  >
                            <div style={style.div}  >
                            <table key='table3' width='90%' style={style.tabla}>
                                <thead>
                                    <tr>
                                        <th width='30%'>Resolucion de ejemplo</th>
                                        <th width='40%'>Ver PDF</th>
                                        <th width='30%'>Plantilla</th>
                                    </tr> 
                                </thead>
                                <tbody>
                                {casoFinal.resolucionRac.plantillas.map(item => (      
                                    <tr key={item.resolucionRacPlantillaId} >
                                        <td>{item.codigo}</td>
                                        <td> <a href={item.link} target='_blank' rel="noreferrer"> {item.nombre} </a> </td>
                                        <td> {item.tienePlantillaDocx == 1 ? 
                                                 <a href={'http://localhost:8080/ejeExpertoRest/public/dwnPlantilla?id='+item.resolucionRacPlantillaId} target='_blank' rel="noreferrer"> {item.nombre} </a>
                                                : '--'} </td>
                                    </tr> 
                                ))}
                                </tbody>
                            </table> 
                            </div>
                        </div>
                    }


                </Form.Field>

                <Grid>
                    <Grid.Column floated='left' width={5}>
                    <Button secondary onClick={() => this.props.next(estados.INICIADO)}>Validar nuevo Caso</Button>
                    </Grid.Column>
                    <Grid.Column floated='right' width={5}>
                    <Button primary onClick={() => alert('Descargar ponencia propuesta de rechazo')}>Finalizar</Button>
                    </Grid.Column>
                </Grid>
                </Form>
            );
        }
    
    }
  }